import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import WrapperContainer from "../../components/WrapperContainer/WrapperContainer.jsx";
import ServiceBusiness from "../../features/ChoiceServices/ServiceBusiness.jsx";

import ButtonsGroup from "../../components/ButtonsGroup/ButtonsGroup.jsx";
import Button from "../../components/Button/Button.jsx";

import handleNotify from "../../utils/helpers/handleNotify.js";
import apiCreateProcessBusiness from "../../api/methods/process";

import { useLocation, useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../router";

import { SERVICES_BUSINESS } from "../../utils/consts/service";
import { ROISTAT_VISIT_ID } from "../../utils/consts";

const ChoiceServiceListBusiness = () => {
  const history = useNavigate();
  const location = useLocation();

  const { mobileConnectionInfo } = useSelector(state => state);

  const { refUserId, phoneNumber } = mobileConnectionInfo;
  const [selectedServices, setSelectedServices] = useState([]);

  const [userComment, setUserComment] = useState("");
  let services = Object.values(SERVICES_BUSINESS);

  const isReferralSber = refUserId.toLowerCase().indexOf("s") !== -1;
  if (isReferralSber) {
    services = Object.values(SERVICES_BUSINESS).filter(
      ({ name: serviceName }) =>
        serviceName === SERVICES_BUSINESS.INTERNET.name ||
        serviceName === SERVICES_BUSINESS.VIDEO.name ||
        serviceName === SERVICES_BUSINESS.PHONE.name
    );
  }

  useEffect(() => {
    if (!phoneNumber) {
      history(APP_ROUTES.MOBILE_CONNECTION.ROOT_ROUTE);
    }
  }, []);

  /**
   * Сформировать перечень услуг
   *
   * @param {Number} serviceId
   */
  const selectService = serviceId => {
    const serviceIds = [...selectedServices];

    if (!serviceIds.includes(serviceId)) {
      serviceIds.push(serviceId);
    } else {
      const serviceIndex = serviceIds.findIndex(id => id === serviceId);
      serviceIds.splice(serviceIndex, 1);
    }

    setSelectedServices(serviceIds);
  };

  /**
   * Создать процесс на подключение услуг для ЮЛ
   */
  const createServices = async () => {
    try {
      const { street, house, fullName, fullAddress, phoneNumber, refUserId } = mobileConnectionInfo;

      const streetId = location?.state?.isDataReferenceBook ? street?.id : undefined;
      const houseId = location?.state?.isDataReferenceBook ? house?.identifire : undefined;

      await apiCreateProcessBusiness(
        streetId,
        houseId,
        fullName,
        fullAddress || undefined,
        phoneNumber,
        selectedServices,
        refUserId,
        ROISTAT_VISIT_ID,
        userComment
      );

      history(APP_ROUTES.MOBILE_CONNECTION.FINISH_BUSINESS_ROUTE);
    } catch (error) {
      handleNotify("error", error);
    }
  };

  return (
    <>
      <WrapperContainer title="sm" gap="16">
        Уфанет для Бизнеса
      </WrapperContainer>
      <div className="forms-container__content">
        <WrapperContainer gap="24" text="lg">
          Выберите услуги
        </WrapperContainer>
        <WrapperContainer gap="24" className="item-list">
          {services.map((service, index) => (
            <ServiceBusiness
              key={index}
              isSelected={selectedServices.includes(service.id)}
              service={service}
              selectService={selectService}
            />
          ))}
        </WrapperContainer>

        <form onSubmit={event => event.preventDefault()}>
          <WrapperContainer gap="24">
            <textarea
              className="textarea"
              placeholder="Комментарий"
              onChange={event => setUserComment(event.target.value)}
              value={userComment}
              rows={3}
            />
          </WrapperContainer>

          <ButtonsGroup>
            <Button isStretch size="xxl" color="secondary" onClick={() => history(-1)}>
              Назад
            </Button>
            <Button
              isSubmit
              isStretch
              size="xxl"
              color="primary"
              onClick={createServices}
              disabled={!selectedServices.length}
            >
              Далее
            </Button>
          </ButtonsGroup>
        </form>
      </div>
    </>
  );
};

export default ChoiceServiceListBusiness;
